<template>
  <el-form class="form" ref="form" label-width="120px">
    <el-form-item label="工单标题">
      <el-input v-model="form.processName" placeholder="工单标题"></el-input>
    </el-form-item>
  <el-form-item label="所属项目">
   <el-select v-model="form.ProjectIdStr">
    <el-option
      v-for="(project, index) of projectList"
      :key="'project-' + index"
      :label="project.ModelName"
      :value="project.IdStr"
     ></el-option>
  </el-select>
  </el-form-item>
    <el-form-item label="备注">
      <el-input type="textarea" v-model="form.description"
      placeholder="请输入备注"></el-input>
    </el-form-item>
    <el-form-item>
      <el-button size="small" type="primary" @click="onSubmit">确认</el-button>
      <el-button size="small" @click="onCancel">取消</el-button>
    </el-form-item>
  </el-form>
</template>
<script>
import { createNewOrder } from '@/api/equipment-operational/index';
import { convertDataToFormData, uuid } from '@/utils/utils';
import DiaFormMixin from '@/components/operating-maintenance/mixins/dia-form-mixin';

export default {
  name: 'create-maintenance-order',
  mixins: [DiaFormMixin],
  props: {
    selectType: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      form: {
        ProjectIdStr: '',
        isNew: true,
        processName: '',
        description: '',
        processLevel: 1,
        schemeCode: this.selectType.F_Code,
      },
      stepList: [],
      equipList: [],
      dialogVisible: false,
    };
  },
  created() {
  },
  computed: {
    projectList() {
      return this.$store.getters.projectList;
    },
  },
  watch: {
  },
  methods: {
    onSubmit() {
      this.form.processId = uuid();
      const formData = convertDataToFormData(this.form);
      createNewOrder(formData).then(() => {
        this.notifyDataChanged();
        this.emitCloseDialog();
      });
    },
    onCancel() {
      this.emitCloseDialog();
    },
  },
};
</script>
